import React, { JSXElementConstructor, ReactElement, useState } from 'react';
import styled from 'styled-components';
import { Icon } from '@iconify/react';
import { BodyText, FlexColumn, FlexRow } from '@make-software/cspr-design';

export const StyledJsonPreview = styled('div')<{ maxWidth?: string }>(({ theme, maxWidth }) =>
  theme.withMedia({
    maxHeight: '14em', // ~5 lines at 1.5em each
    maxWidth: maxWidth ? maxWidth : '300px',
    overflowY: 'auto',
    fontFamily: 'monospace',
    whiteSpace: 'pre-wrap',
    backgroundColor: '#f8f8f8',
    padding: '0.5em',
    border: '1px solid #ddd',
    borderRadius: '4px'
  })
);

interface CollapsibleContentProps {
  json?: any;
  htmlContent?: React.ReactElement;
  maxWidth?: string;
}

const CollapsibleContentPreview = ({ json, htmlContent, maxWidth }: CollapsibleContentProps) => {
  const [collapsed, setCollapsed] = useState(true);
  if (
    (json === undefined || json === null) &&
    (htmlContent === undefined || htmlContent === null)
  ) {
    return <BodyText size={3}>No data</BodyText>;
  }
  const formattedJson = json ? JSON.stringify(json, null, 2) : htmlContent;

  return (
    <FlexColumn style={{ minWidth: '300px', marginBottom: '10px' }} gap={8}>
      <FlexRow align={'center'} justify={'space-between'}>
        <BodyText size={3} style={{ flex: 1 }}>
          {'{...}'}
        </BodyText>
        <button
          onClick={() => setCollapsed(!collapsed)}
          style={{
            display: 'flex',
            alignItems: 'center',
            background: 'none',
            border: 'none',
            color: '#0070f3',
            cursor: 'pointer',
            padding: 0,
            flexShrink: 0
          }}
        >
          <BodyText size={3}>{collapsed ? 'Expand' : 'Collapse'} </BodyText>
          {collapsed ? (
            <Icon icon={'mdi:chevron-down'} style={{ marginLeft: 5 }} />
          ) : (
            <Icon icon={'mdi:chevron-up'} style={{ marginLeft: 5 }} />
          )}
        </button>
      </FlexRow>
      <StyledJsonPreview style={{ display: collapsed ? 'none' : 'block' }} maxWidth={maxWidth}>
        {formattedJson}
      </StyledJsonPreview>
    </FlexColumn>
  );
};

export default CollapsibleContentPreview;
